import moment from 'moment'

function formatDate (times) {
  return moment(times * 1000).format('YYYY.MM.DD')
}

// 时间戳转换时间
function formatTimestamp (times) {
  return moment(times * 1000).format('YYYY.MM.DD HH:mm:ss')
}

function formatYMDHMS (times) {
  return moment(times * 1000).format('YYYY年MM月DD日 HH时mm分ss秒')
}

function formatYMD (times) {
  return moment(times * 1000).format('YYYY年MM月DD日')
}

function formatMD (times) {
  return moment(times * 1000).format('MM月DD日')
}

function formatMDHMS (times) {
  return moment(times * 1000).format('MM月DD日  HH:mm:ss')
}

function formatYMDHM (times) {
  return moment(times * 1000).format('YYYY.MM.DD HH:mm')
}

function formatHMS (times) {
  return moment(times * 1000).format('HH:mm:ss')
}
function payCountDown (time) {
  const mm = Math.floor(time / 60)
  const ss = time % 60
  return (String(mm).length > 1 ? mm : '0' + mm) + ':' + (String(ss).length > 1 ? ss : '0' + ss)
}

function defaultTeacherImg (src, gender) {
  if (src) {
    return src
  } else {
    return gender === 1 ? '//cdn.eduzhixin.cn/cdn/img/live/teacher-nan.png' : '//cdn.eduzhixin.cn/cdn/img/live/teacher-nv.png'
  }
}

function displayPrice (price) {
  return Number((Number(price) / 100).toFixed(2))
}

function lianbaoTypeText (discountType, discountVal) {
  const type = discountType
  const val = discountVal
  if (type === 1) {
    return '联报' + Number((val / 10).toFixed(1)) + '折'
  } else if (type === 2) {
    return '直减¥' + Number((val / 100).toFixed(2))
  } else {
    return ''
  }
}
function getLianbaoTagVisible (type, info) {
  const cartSwitchUnion = true
  if (cartSwitchUnion === false) {
    return {
      isLianbao: false,
      isShowLianbao: false
    }
  }
  const isEnded = info && info.end_at < (+new Date() / 1000)
  const hasBeginned = info && info.begin_at < (+new Date() / 1000)
  const isLianbao = !isEnded && type === 2 && hasBeginned
  return isLianbao
}
function handleCountPrice (e) {
  let price = e
  if (String(price).indexOf('.') > -1) {
    price = price.toFixed(2)
  }
  return price
}
function handleSubject (e) {
  const subject = e.includes('PHY')
    ? '物理'
    : e.includes('BIO')
      ? '生物'
      : e.includes('CHEM')
        ? '化学'
        : e.includes('MATH')
          ? '数学'
          : e.includes('CHN')
            ? '语文'
            : e.includes('ENG')
              ? '英语'
              : e.includes('ZI')
                ? '自招'
                : ''
  return subject
}
function handleClassType (e) {
  switch (e) {
    case 1001:
      return '系统课'
    case 1002:
      return '专题课'
    case 1003:
      return '讲座'
    case 1004:
      return '学院直播课'
    case 3:
      return '同步班'
    case 4:
      return '强基班'
    case 5:
      return '竞赛班'
  }
}
export default {
  formatMD,
  formatYMD,
  formatYMDHMS,
  formatYMDHM,
  formatMDHMS,
  formatDate,
  formatTimestamp,
  payCountDown,
  defaultTeacherImg,
  displayPrice,
  lianbaoTypeText,
  getLianbaoTagVisible,
  formatHMS,
  handleCountPrice,
  handleSubject,
  handleClassType
}
